import { useMemo } from 'react'
import { useCacheSlice } from '../hooks'

export type CaseListMatter = {
  matter_id: string
}

export function useCaseListCache() {
  const { data, isLoading, lastFetchedAt } = useCacheSlice('case_list')
  const rows = data as CaseListMatter[]
  const caseListIds = useMemo(
    () => new Set(rows.map((r) => r.matter_id)),
    [rows],
  )
  const isInitialLoading = isLoading && lastFetchedAt === 0
  return { caseListIds, isLoading: isInitialLoading }
}
